const country = ["Portugal"];
const preferedDeliveryDate = ["ASAP", "1-2 weeks", "2-4 weeks", "1-2 months", "2-3 months"];

const allFiltersMock = {
    country,
    preferedDeliveryDate
}

export default allFiltersMock;